/***
 *
 *   404
 *   Phase 10 — reference NotFoundPage chrome.
 *
 **********/

import React from 'react';
import { Button, Icon, useNavigate } from 'components/lib';
import { useTranslate } from 'app/translations';

export function NotFound(props) {
    const { _t } = useTranslate();
    const navigate = useNavigate();

    return (
        <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-6 py-16 text-center">
            <div className="rounded-full bg-primary-50 p-4 text-primary-600 dark:bg-primary-900/40 dark:text-primary-300">
                <Icon image="help-circle" size={40} color="currentColor" />
            </div>
            <div className="max-w-md space-y-2">
                <h1 className="text-xl font-semibold text-text-primary">404</h1>
                <p className="text-sm text-text-secondary">{_t('error.message')}</p>
            </div>
            <Button
                variant="accent"
                text={_t('message.home')}
                action={() => navigate('/')}
            />
        </div>
    );
}
